import * as Employee_en from './Employee.en.js';
import * as Employee_es from './Employee.es.js';

const EmployeeTuple = [
  { type: 'Employee', language: 'en', object: Employee_en.default },
  { type: 'Employee', language: 'es', object: Employee_es.default },
];

export default EmployeeTuple;